<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMessageFormatter } from 'shared/composables/useMessageFormatter';
import NextButton from 'dashboard/components-next/button/Button.vue';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

defineProps({
  content: {
    type: String,
    required: true,
  },
  buttonClass: {
    type: String,
    default: '',
  },
});

const { t } = useI18n();
const { formatMessage } = useMessageFormatter();
const dialogRef = ref(null);

const open = () => dialogRef.value?.open();
const close = () => dialogRef.value?.close();
</script>

<template>
  <div class="contents">
    <template v-if="content">
      <NextButton
        v-tooltip="t('CORTEX.PLAYGROUND.RESPONSE_VIEWER.OPEN')"
        xs
        ghost
        slate
        icon="i-lucide-maximize"
        :aria-label="t('CORTEX.PLAYGROUND.RESPONSE_VIEWER.OPEN')"
        :class="buttonClass || 'absolute top-2 z-10 ltr:right-6 rtl:left-6'"
        @click="open"
      />
      <Dialog
        ref="dialogRef"
        width="6xl"
        position="top"
        :title="t('CORTEX.PLAYGROUND.RESPONSE_VIEWER.TITLE')"
        :show-confirm-button="false"
        :show-cancel-button="false"
      >
        <div
          v-dompurify-html="formatMessage(content, false)"
          class="prose-bubble max-h-[calc(100vh-12rem)] overflow-y-auto pr-2 text-sm leading-relaxed text-n-slate-12"
        />
        <template #footer>
          <div class="flex justify-end">
            <NextButton
              sm
              outline
              slate
              icon="i-lucide-x"
              :label="t('CORTEX.PLAYGROUND.RESPONSE_VIEWER.CLOSE')"
              @click="close"
            />
          </div>
        </template>
      </Dialog>
    </template>
  </div>
</template>
